"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorMode;
(function (EditorMode) {
    EditorMode[EditorMode["Map"] = 0] = "Map";
    EditorMode[EditorMode["Store"] = 1] = "Store";
    EditorMode[EditorMode["Code"] = 2] = "Code";
})(EditorMode = exports.EditorMode || (exports.EditorMode = {}));
